import React from "react";
import { useLocation } from "react-router-dom";

import { Layout, Descriptions, Tag } from "antd";
import dayjs from "dayjs";
import { tagColorByStatus } from "utils/labels";

var localizedFormat = require("dayjs/plugin/localizedFormat");
dayjs.extend(localizedFormat);
const { Content } = Layout;

// const table = "transactions"

const View = () => {
  const { state } = useLocation();

  console.log(state);

  return (
    <Content>
      {/* <Breadcrumb>
        <Breadcrumb.Item>Transaction</Breadcrumb.Item>
        <Breadcrumb.Item>Edit</Breadcrumb.Item>
      </Breadcrumb> */}
      <Descriptions title="Quote Info" layout="vertical" bordered>
        <Descriptions.Item label="Quote" span={3}>
          {state.content}
        </Descriptions.Item>
        <Descriptions.Item label="Title" span={3}>
          {state.title}
        </Descriptions.Item>
        <Descriptions.Item label="Author" span={3}>
          {state?.author?.fullName}
        </Descriptions.Item>
        <Descriptions.Item label="Topics" span={3}>
          {state?.topics?.map((topic) => (
            <Tag>{topic.name}</Tag>
          ))}
        </Descriptions.Item>
        <Descriptions.Item label="Created At">
          {dayjs(state.createdAt).format("L LT")}
        </Descriptions.Item>
        <Descriptions.Item label="Updated At">
          {dayjs(state.updatedAt).format("L LT")}
        </Descriptions.Item>
        <Descriptions.Item label="Status" span={3}>
          <Tag color={tagColorByStatus(state.status)}>{state.status}</Tag>
        </Descriptions.Item>
      </Descriptions>
    </Content>
  );
};

export default View;
